export const dialogState = $state({
  current: null,
});

let resolveCurrent = null;

function requestDialog(type, options = {}) {
  if (resolveCurrent) resolveCurrent(null);
  dialogState.current = { type, ...options };
  return new Promise((resolve) => {
    resolveCurrent = resolve;
  });
}

export const openFileDialog = (options = {}) => requestDialog('open-file', options);
export const saveFileDialog = (options = {}) => requestDialog('save-file', options);
export const chooseAppDialog = (options = {}) => requestDialog('choose-app', options);
export const requestPermissionDialog = (permission) => requestDialog('permission', { permission });
export const confirmDialog = (options = {}) => requestDialog('confirm', options);

export function resolveDialog(value) {
  resolveCurrent?.(value);
  resolveCurrent = null;
  dialogState.current = null;
}

export function cancelDialog() {
  resolveDialog(null);
}
